/**
 * Centralized config detection for test vs. live system.
 * Replaces the duplicated `isTestsystem` / `API_BASE` / `TOKEN_KEY` logic
 * previously scattered across api.ts, AuthContext.tsx, and LoginPage.tsx.
 */

export const isTestsystem: boolean =
  typeof window !== 'undefined' && window.location.pathname.includes('/testsystem/');

export const TOKEN_KEY: string = isTestsystem ? 'sd_token_test' : 'sd_token';

export const API_BASE: string =
  (typeof process !== 'undefined' && (process.env as any).REACT_APP_API_URL) ||
  (isTestsystem
    ? 'https://www.noweakweek.com/testsystem/backend/public'
    : 'https://www.noweakweek.com/backend/public');
